import classNames from 'classnames';
import styled from 'styled-components';

import { unitMapping, type Unit } from '#src/lib/style.ts';

const Root = styled.svg`
  &.inactive {
    filter: grayscale(1) brightness(3);
    opacity: 0.5;
  }
`;

type Props = { inactive?: boolean; size?: Unit };
export const LineupBonuses = ({ inactive, size = 2 }: Props) => {
  return (
    <Root
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      className={classNames({ inactive })}
    >
      <rect
        y="-1.06066"
        width="22.5"
        height="22.5"
        transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 17.25 33.1894)"
        fill="#00210F"
        stroke="#3DDC84"
        strokeWidth="1.5"
      />
      <path
        d="M25.7921 19.8038L25.2628 20.334L24.7325 19.8047L18.0001 13.0957L11.2676 19.8047L10.7374 20.334L10.2081 19.8038L8.20221 17.7979L7.67096 17.2676L8.20221 16.7373L18.0001 6.9395L28.3282 17.2676L25.7921 19.8038ZM25.7921 27.3038L25.2628 27.834L24.7325 27.3047L18.0001 20.5957L11.2676 27.3047L10.7374 27.834L10.2081 27.3038L8.20221 25.2979L7.67096 24.7676L8.20221 24.2373L18.0001 14.4395L28.3282 24.7676L25.7921 27.3038Z"
        fill="#3DDC84"
        stroke="#00210F"
        strokeWidth="1.5"
      />
    </Root>
  );
};
